module.exports = __webpack_public_path__ + "static/media/duckCreekSquareLogo.7b1e32d1.png";